<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 36 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="4" rx="2" fill="#898989" />
    <rect width="36" height="4" rx="2" fill="#898989" />
    <rect y="6" width="36" height="4" rx="2" fill="#898989" />
    <rect y="12" width="36" height="4" rx="2" fill="#898989" />
  </svg>
</template>
